import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Initialize scroll-triggered fade animations
 */
const fadeAnimations = () => {
  // If the user prefers reduced motion, skip animations
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  // Define animation classes with their initial and animation properties
  const animationClasses = {
    "fade-left": {
      initialProps: { x: -20, opacity: 0 },
      animProps: { x: 0, opacity: 1 }
    },
    "fade-right": {
      initialProps: { x: 20, opacity: 0 },
      animProps: { x: 0, opacity: 1 }
    },
    "fade-up": {
      initialProps: { y: 20, opacity: 0 },
      animProps: { y: 0, opacity: 1 }
    },
    "fade-down": {
      initialProps: { y: -20, opacity: 0 },
      animProps: { y: 0, opacity: 1 }
    },
    "fade-in": {
      initialProps: { opacity: 0 },
      animProps: { opacity: 1 }
    }
  };

  // Animate stagger containers first
  document.querySelectorAll(".stagger-anim").forEach((staggerContainer) => {
    const elements = staggerContainer.querySelectorAll(
      ".fade-left:not(.animated), .fade-right:not(.animated), .fade-up:not(.animated), .fade-down:not(.animated), .fade-in:not(.animated)"
    );

    const speed = staggerContainer.dataset.speed || 1;
    const stagger = speed / 5;

    if (elements.length) {
      // Set initial states
      elements.forEach((element) => {
        const className = Array.from(element.classList).find((cls) =>
          Object.keys(animationClasses).includes(cls)
        );

        gsap.set(element, animationClasses[className].initialProps);
      });

      // Animate with stagger
      gsap.to(elements, {
        scrollTrigger: {
          trigger: staggerContainer,
          start: "top 75%",
          toggleActions: "play none none none"
        },
        opacity: 1,
        x: 0,
        y: 0,
        stagger: stagger,
        duration: speed,
        ease: "power2.out",
        onComplete: () => {
          // add completed class to all elements
          elements.forEach((element) => {
            element.classList.add("animated");
          });
        }
      });
    }
  });

  // Then animate individual elements
  Object.entries(animationClasses).forEach(([className, config]) => {
    const elements = document.querySelectorAll(`.${className}:not(.stagger-anim .${className})`);

    elements.forEach((element) => {
      // Skip elements in stagger containers
      if (element.closest(".stagger-anim")) return;
      if (element.classList.contains("animated")) return;

      // Set initial state
      gsap.set(element, config.initialProps);

      // Create ScrollTrigger for each element
      gsap.to(element, {
        ...config.animProps,
        scrollTrigger: {
          trigger: element,
          start: "top 75%",
          toggleActions: "play none none none"
        },
        duration: 1,
        ease: "power2.out",
        onComplete: () => {
          element.classList.add("animated");
        }
      });
    });
  });
};

export { fadeAnimations };
